import { z } from 'zod';
// `neutral` is a withdrawn vote, distinct from a conversation never rated.
export const EvaluationRatingSchema = z.enum(['positive', 'negative', 'neutral']);
export const ConversationEvaluationSchema = z.object({
    rating: EvaluationRatingSchema,
    comment: z.string().optional(),
    createdAt: z.iso.datetime()
});
export const EVALUATION_COMMENT_MAX_LENGTH = 2000;
export const CreateConversationEvaluationRequestSchema = z.object({
    rating: EvaluationRatingSchema,
    comment: z.string().trim().min(1).max(EVALUATION_COMMENT_MAX_LENGTH).optional()
}).refine(({ rating, comment }) => comment === undefined || rating === 'negative', {
    message: 'A comment is only accepted on a negative rating'
});
